var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Inject } from 'vue-property-decorator';
import { INJECT_UICORE_RENDERER } from "../../../../lib/utils/consts";
import { makeEvalFn } from "../../../../lib/utils/stringInterop";
let UcWatchValue = class UcWatchValue extends Vue {
  created() {
    // 屏蔽一切 watch
    if (this.$attrs['data-uc-design-mode']) return;
    this.$watch(() => `${this.expression}\n${!!this.immediate}\n${!!this.deep}`, () => {
      var _this$unwatch;
      (_this$unwatch = this.unwatch) === null || _this$unwatch === void 0 || _this$unwatch.call(this);
      const {
        renderer
      } = this;
      const getExprValue = makeEvalFn(this.expression, 1).bind(renderer, renderer);
      this.unwatch = this.$watch(getExprValue, (newVal, oldVal) => {
        this.$emit('change', newVal, oldVal);
      }, {
        immediate: !!this.immediate,
        deep: !!this.deep
      });
    }, {
      immediate: true
    });
  }
  beforeDestroy() {
    var _this$unwatch2;
    (_this$unwatch2 = this.unwatch) === null || _this$unwatch2 === void 0 || _this$unwatch2.call(this);
  }
};
__decorate([Prop()], UcWatchValue.prototype, "expression", void 0);
__decorate([Prop()], UcWatchValue.prototype, "immediate", void 0);
__decorate([Prop()], UcWatchValue.prototype, "deep", void 0);
__decorate([Inject(INJECT_UICORE_RENDERER)], UcWatchValue.prototype, "renderer", void 0);
UcWatchValue = __decorate([Component({
  name: 'UcWatchValue'
})], UcWatchValue);
const WatchValueComponentMeta = {
  id: 'uc-watch-value',
  type: 'trigger',
  name: '数据变化监测器',
  component: UcWatchValue,
  events: [{
    id: 'change',
    name: '数据发生变化',
    desc: '可通过 `$event` 访问到新的值，`flow.args[1]` 访问到旧的值（不一定准确）',
    arguments: [{
      type: 'any',
      description: '新的值'
    }, {
      type: 'any',
      description: '旧的值（可能不准确）'
    }]
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'expression',
      type: 'string',
      title: '监测什么',
      default: '',
      'uc:allowInterop': false,
      ui: {
        type: 'exprInput',
        props: {
          type: 'javascript',
          multipleLine: true,
          placeholder: '填入变量路径，或者JS表达式',
          notifyVoidReturn: true
        }
      }
    }, {
      id: 'immediate',
      type: 'boolean',
      title: '开始监测时，就立即触发一次事件'
    }, {
      id: 'deep',
      type: 'boolean',
      title: '监测对象深层变化',
      description: '深度监听对象下每一个字段，但是可能有性能问题'
    }]
  },
  getLayoutName(layout) {
    const MAX_LENGTH = 16;
    const {
      expression
    } = layout.props || {};
    if (!expression) return '待配置数据变化监测器';
    if (typeof expression !== 'string') return '数据变化监测器';
    return `监测 ${expression.length <= MAX_LENGTH ? expression : `…${expression.slice(-MAX_LENGTH)}`} 数据变化`;
  }
};
export default WatchValueComponentMeta;
//# sourceMappingURL=WatchValue.js.map
